export enum Currency {
  EUR = "eur",
  USD = "usd",
}
